module.exports = __webpack_public_path__ + "static/media/Icon_Books_Opacity70.f0783d31.png";